export default `
<g fill="currentColor" stroke-width="2">
	<rect x="11.58" y="7.33" class="st0" width="0.84" height="6.02"/>
	<path class="st0" d="M12,2.08c-5.47,0-9.92,4.45-9.92,9.92s4.45,9.92,9.92,9.92s9.92-4.45,9.92-9.92S17.47,2.08,12,2.08z M12,21.08
		c-5.01,0-9.08-4.07-9.08-9.08S6.99,2.92,12,2.92s9.08,4.07,9.08,9.08S17.01,21.08,12,21.08z"/>
	<circle class="st0" cx="12" cy="15.57" r="0.58"/>
</g>
`;
